<template>
  <HeraFormSwitch
    v-model="qualificationType"
    class="col-4"
    :label="$$t('Qualification type', 'qualification_type_label')"
    name="qualificationType"
    :disabled="isTournamentFieldDisabled('qualification_type')"
    :true-label="$$t('Random')"
    :false-label="$$t('First registered')"
    true-value="random"
    false-value="first_registered"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import HeraFormSwitch from '@/components/atoms/form/HeraFormSwitch';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentQualificationTypeSetting',
  components: {
    HeraFormSwitch,
  },
  mixins: [translate('_web_tournament_additional_settings')],
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    qualificationType: {
      get() {
        const type = this.$lodash.get(
          this.currentTournament,
          'players_config.qualification_type',
          null
        );
        return type === 'none' ? 'first_registered' : type;
      },
      set(val) {
        this.updateCurrentTournament({
          qualification_type: val,
          component: 'players_config',
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>
